import loadable from '@loadable/component';

export const UserDashboardAccountSettingsPageLoadable = loadable(
  () => import('./UserDashboardAccountSettingsPage.dynamic'),
);
